// Function to generate header data for the Excel sheet
const headerData = (title) => {
    const headerVal = []
    headerVal.push(title)
    headerVal.push('')
    headerVal.push('')
    return headerVal
}

// Function to generate the body of the Excel sheet based on the report data
const excelBody = (vm) => {
    const excelData = []
            const myObj = {}
            myObj[vm.$t('child_reports.institute_name_address') + '(' + vm.$n(1) + ')'] = vm.titleData.institute_name
            myObj[vm.$t('child_reports.approved_seats') + '(' + vm.$n(2) + ')'] = vm.$n(vm.report_data.approved_seats)
            myObj[vm.$t('child_reports.no_residents') + '(' + vm.$n(3) + ')'] = vm.$n(vm.report_data.no_residents)
            myObj[vm.$t('child_reports.residents_admitted') + '(' + vm.$n(4) + ')'] = vm.$n(vm.report_data.residents_admitted)
            myObj[vm.$t('child_reports.total_resident') + '(' + vm.$n(3) + '+' + vm.$n(4) + ' = ' + vm.$n(5) + ')'] = vm.$n(vm.report_data.no_residents + vm.report_data.residents_admitted)
            myObj[vm.$t('child_reports.total_rehabilitation_month') + '(' + vm.$n(6) + ')'] = vm.$n(vm.report_data.total_rehabilitation_month)
            myObj[vm.$t('child_reports.total_release_month') + '(' + vm.$n(7) + ')'] = vm.$n(vm.report_data.total_release_month)
            myObj[vm.$t('child_reports.total_residents_month') + '[' + vm.$n(5) + '-' + '(' + vm.$n(6) + '+' + vm.$n(7) + ')' + ' = ' + vm.$n(8) + ']'] = vm.$n(vm.report_data.no_residents + vm.report_data.residents_admitted - vm.report_data.total_rehabilitation_month - vm.report_data.total_release_month)
            myObj[vm.$t('child_reports.total_rehabilitated_residents_admission') + '(' + vm.$n(9) + ')'] = vm.$n(vm.report_data.total_rehabilitated_residents_admission)
            myObj[vm.$t('child_reports.total_rehabilitated_residents') + '(' + vm.$n(10) + ')'] = vm.$n(vm.report_data.total_rehabilitated_residents)
            myObj[vm.$t('child_reports.total_rehabilitated_residents') + '(' + vm.$n(11) + ')'] = vm.$n(vm.report_data.total_release_residents)
            myObj[vm.$t('child_reports.Comments') + '(' + vm.$n(12) + ')'] = vm.report_data.Comments

            excelData.push(myObj)
    return excelData
}

export default {
    headerData,
    excelBody
}
